import React, { Component } from 'react'
import { connect } from 'react-redux'
import { savePaymentMethod } from '../actions/account'
import CardIcon from 'react-icons/lib/io/card'
import ChangePayment from '../components/account/ChangePayment'
import dateformat from 'dateformat'
import { formatMoney } from 'accounting'

@connect(state => ({account: state.auth.account}), {savePaymentMethod})
export default class extends Component {
  state = {
    addCard: !this.props.account.billing_info || this.props.account.billing_status === 'failed'
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.account.billing_info !== this.props.account.billing_info) {
      this.setState({addCard: false})
    }
  }

  onToggle = () => {
    this.setState(prevState => ({addCard: !prevState.addCard}))
  }

  render () {
    const {addCard} = this.state
    const {account} = this.props
    const billing = account.billing_info

    return <div>
      {billing &&
        <div className='card-info'>
          <h4>Your Current Card</h4>
          <p>
            <CardIcon size={16} />&nbsp;
            <strong>{billing.brand} **** **** **** {billing.last4}</strong>&nbsp;
            Expiration: <strong>{billing.exp}</strong>
          </p>
          <p>
            <strong>Next payment: </strong>
            {dateformat(new Date(account.subscription.next_payment * 1000), 'longDate')}<br />
            <strong>Amount: </strong>
            {formatMoney(parseFloat(account.subscription.amount / 100))}
          </p>
          {!addCard &&
            <p className='text-center'>
              <button className='btn' onClick={this.onToggle}>Change</button>
            </p>
          }
        </div>
      }
      {account.billing_status === 'failed' &&
        <p className='text-danger'>Payment method failed to process, please add a new card.</p>
      }
      {addCard &&
        <div className='information'>
          <h3 className='information-header'>{billing ? 'Change' : 'Add'} Card</h3>
          <ChangePayment
            onSubmit={this.props.savePaymentMethod}
            onCancel={billing ? this.onToggle : null}
          />
        </div>
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/AccountBilling.js